import React, { useMemo } from 'react';
import { Input } from '@v2/components';
import PimsConfigRow from '../PimsConfigRow';
import { styles } from './styles';
import type { PimsConfigTableProps } from './types';

const PimsConfigTable: React.FC<PimsConfigTableProps> = ({
  configurations,
  search,
  onSearchChange,
  onUpdateConfig,
  updatingConfigId,
}) => {
  const filtered = useMemo(
    () => configurations.filter(c => c.key.toLowerCase().includes(search.toLowerCase())),
    [configurations, search],
  );

  return (
    <div className={styles.container}>
      <div className={styles.searchWrapper}>
        <Input
          placeholder="Filter by key..."
          value={search}
          onChange={e => onSearchChange(e.target.value)}
        />
      </div>
      {filtered.length === 0 ? (
        <div className={styles.emptyMessage}>
          {configurations.length === 0
            ? 'No configurations.'
            : 'No configurations match the filter.'}
        </div>
      ) : (
        <div className={styles.list}>
          {filtered.map(config => (
            <PimsConfigRow
              key={config.id}
              config={config}
              onSave={onUpdateConfig}
              isSaving={updatingConfigId === config.id}
            />
          ))}
        </div>
      )}
    </div>
  );
};

export { PimsConfigTable };
export default PimsConfigTable;
